<template>
  <div class="no-content-box" :style="style">
    <img :src="nullImage" alt="" />
    <p v-if="title" class="no-content-head">{{ title }}</p>
    <p class="no-content-text">{{ text || $t('base_no_content') }}</p>
  </div>
</template>
<script setup lang="ts">
import nullImage from '~~/assets/imgs/error/error_no_content.png'
defineProps({
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  style: {
    type: Object,
    default: null,
  },
})
</script>
<style lang="less" scoped>
.no-content-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    margin-bottom: 12px;
    width: 180px;
    height: 180px;
  }
  .no-content-head {
    width: 250px;
    line-height: 22px;
    font-size: 16px;
    color: @Text50;
    text-align: center;
    margin-bottom: 8px;
  }
  .no-content-text {
    width: 250px;
    line-height: 20px;
    font-size: 14px;
    color: @Text30;
    margin-bottom: 24px;
    text-align: center;
  }
}
</style>
